const Groups = {
  1: "ODONTOLOGIA",
  2: "PEDIATRIA",
  3: "IMPLANTES",
  4: "ORTODONCIA"
};

export default Groups;